import { useCallback } from "react";

import { useOutletContext } from "@zenith/context";
import { OutletApiService, OutletListDTO } from "@zenith/services/user";

/**
 * Signs the user into an outlet. Every request after it acts on that outlet's
 * wallet, so writes made from All Outlets switch to their outlet first.
 */
export const useSwitchOutlet = () => {
  const { outletContext, setOutlets } = useOutletContext();
  const { outlets } = outletContext;

  return useCallback(
    async (outlet: OutletListDTO): Promise<void> => {
      if (!outlet.id || outlet.isCurrent) return;

      await OutletApiService.switchOutlet({ outletId: outlet.id });
      setOutlets(
        outlets.map((item) => ({ ...item, isCurrent: item.id === outlet.id }))
      );
    },
    [outlets, setOutlets]
  );
};
